exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popup-overlay[data-v-0f4ee945]{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);display:flex;justify-content:center;align-items:center;z-index:1000}.popup-container[data-v-0f4ee945]{background-color:#fff8c2;padding:20px;border-radius:8px;max-width:400px;width:100%;position:relative}.popup-header[data-v-0f4ee945]{display:flex;justify-content:space-between;align-items:center}.popup-title[data-v-0f4ee945]{font-size:18px;font-weight:700}.close-btn[data-v-0f4ee945]{background:none;border:none;font-size:24px;cursor:pointer;color:#333;position:absolute;top:5px;right:5px;padding:0;width:20px;height:20px;text-align:center;line-height:20px}.close-btn[data-v-0f4ee945]:hover{color:red}.popup-body[data-v-0f4ee945]{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-0f4ee945","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/WarningMessage.vue
// module id = 535
// module chunks = 0